// extracted by mini-css-extract-plugin
export default {"loader":"TiktokLoading_loader__Btstm","small":"TiktokLoading_small__lu2QW","revolve":"TiktokLoading_revolve__-LV8q"};